import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import CloseIcon from "../img/svg/close_blue_new_design.svg";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialog-paper": {
    borderRadius: "var(--dialog-border-radius)",
  },
}));

export default function SelectDateTimePopup({
  isOpen,
  setIsOpen,
  headerText,
  bodyText,
  oneLineTitle,
  cancelBtnText,
  confirmBtnText,
  onConfirm = () => {},
  clubName,
  selectedHours,
  selectedMinutes,
  selectedDays,
}) {
  const { t } = useTranslation();
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      sx={{ p: 0 }}
    >
      <Box>
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "3px",
            textAlign: "center",
            width: "75vw",
          }}
          id="customized-dialog-title"
        >
          <img src={CloseIcon} alt="close" onClick={handleClose} />
          <Typography
            className="open-sans-hebrew"
            gutterBottom
            sx={{
              fontSize: "24px",
              m: 0,
              color: "var(--darkblue)",
              textAlign: "center",
              fontWeight: 700,
              fontFamily: `var(--font-family) !important`,
            }}
          >
            {headerText}
          </Typography>
        </DialogTitle>
      </Box>
      <DialogContent>
        <Typography
          className="test"
          sx={{
            fontFamily: `var(--font-family) !important`,
            fontSize: "16px",
            m: 0,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            alignItems: "flex-end",
            mb: "5px",
          }}
        >
          <span
            style={{
              textAlign: "right",
              color: "#565656",
              display: "flex",
              flexDirection: "column-reverse",
            }}
          >
            {oneLineTitle ? (
              <span
                style={{
                  letterSpacing: "-1px",
                  direction: "rtl",
                  marginLeft: "5px",
                }}
              >
                {t("BOOK_WORKOUT_QUESTION")} {clubName}
              </span>
            ) : (
              <>
                <span style={{ letterSpacing: "-1px", marginLeft: "5px" }}>
                  {t("BOOK_WORKOUT_QUESTION")}
                </span>
                <span style={{ letterSpacing: "-1px", direction: "rtl" }}>
                  {clubName}
                </span>
              </>
            )}
          </span>
          <span
            style={{
              color: "#565656",
            }}
          >
            <span>
              {selectedHours}:{selectedMinutes}{" "}
            </span>
            <span>{t("ON_DATE")} </span>
            <span>{selectedDays}</span>
            <span> {t("AT_TIME")} </span>
          </span>
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 0, m: "0px" }}>
        <Button
          onClick={() => {
            handleClose();
            onConfirm();
          }}
          sx={{ py: "16px" }}
          variant="contained"
          className="phone-dialog-btn phone-dialog-darkblue-btn"
        >
          {confirmBtnText}
        </Button>
        <Button
          sx={{ py: "16px" }}
          variant="contained"
          className="phone-dialog-btn phone-dialog-secondary-red-btn"
          onClick={handleClose}
        >
          {cancelBtnText}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}
